import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../components/Card'

const VideoFrame = styled.iframe`
  width: 100%;
  height: 60vh;
  border: 0;
`

@observer
export default class Video extends Component {
  @observable scriptShown = false

  @action
  toggleScript = () => {
    this.scriptShown = !this.scriptShown
  }

  render() {
    return (
      <Card>
        <Card.Title str="prose.howToPutInEyeDrops" />
        <Card.Pad>
          <VideoFrame title="learn-video" src="https://www.youtube-nocookie.com/embed/k6fWCAkwlcI?rel=0&showinfo=0&modestbranding=1" />
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UseVideo.js